const ENVIRONMENTS = [
    // DEV (LOCAL)
    {
        name: 'dev',
        front: 'http://localhost',
        api: 'http://elite-series-api.gfinity.local'
        // api: 'http://api.ig.esportsindev.com'
    },

    // DEV (LOCAL 2)
    {
        name: 'dev',
        front: 'elite-series.gfinity.local',
        api: 'http://elite-series-api.gfinity.local'
    },

    // DEV (LOCAL): Damien
    {
        name: 'dev',
        front: 'http://192.168.1.18',
        api: 'https://api.elite-series.gfinity.imm-g-prod.com'
    },

    // DEV (LOCAL): Florian
    {
        name: 'dev',
        front: 'http://192.168.1.97',
        api: 'http://api.elite-series.gfinity.imm-g-prod.com'
    },

    // DEV (LOCAL): Florian
    {
        name: 'dev',
        front: 'http://192.168.1.97',
        api: 'http://api.elite-series.gfinity.imm-g-prod.com'
    },

    // DEV (LOCAL): Bruno
    {
        name: 'dev',
        front: 'http://192.168.1.80',
        api: 'http://api.elite-series.gfinity.imm-g-prod.com'
    },

    // PREPROD (IG)
    {
        name: 'preprod',
        front: 'http://elite-series.gfinity.imm-g-prod.com',
        api: 'https://api.elite-series.gfinity.imm-g-prod.com'
    },

    // PREPROD (Gfinity)
    {
        name: 'preprod',
        front: 'http://front.ig.esportsindev.com',
        api: 'http://api.ig.esportsindev.com'
    },

    // PROD
    {
        name: 'prod',
        front: 'https://gfinityesports.com',
        api: 'https://api.gfinityesports.com'
    }
]


const currentURL = window.location.href.toLowerCase()
const testFont = env => currentURL.search(env.front.toLowerCase()) > -1

const env = ENVIRONMENTS.find(testFont) || ENVIRONMENTS[ENVIRONMENTS.length - 1]

export default {
    env,

    api:
    {
        base: env.api,
        global: env.api + '/:lang/global',
        home: env.api + '/:lang/home',

        news: env.api + '/:lang/news',
        article: env.api + '/:lang/news/details',
        // └─▶ /static/api/article.json?slug=my-slug-value

        teams: env.api + '/:lang/teams',
        esStandings: env.api + '/:lang/teams/standings',
        teamProfile: env.api + '/:lang/teams/details',
        // └─▶ /static/api/teams.json?slug=my-slug-value

        videos: env.api + '/:lang/videos',
        videoPlayer: env.api + '/:lang/videos/details',
        // └─▶ /static/api/video-player.json?slug=my-slug-value

        watchNow: env.api + '/:lang/watch-now',
        esMatchDetails: env.api + '/:lang/matches/details',
        // └─▶ /static/api/es-details.json?slug=my-slug-value

        player: env.api + '/:lang/players/details',
        // └─▶ /static/api/player.json?slug=my-slug-value

        sponsors: env.api + '/:lang/sponsors',

        policy: env.api + '/:lang/policy',
        terms: env.api + '/:lang/terms',
        copyright: env.api + '/:lang/copyright',
        esAbout: env.api + '/:lang/about',
        esInformations: env.api + '/:lang/informations',
        esSeason: env.api + '/:lang/seasons/details',
        intraVideo: env.api + '/:lang/intra/video',
        gallery: env.api + '/:lang/gallery', // Change when API is done

        esMatches: env.api + '/:lang/matches',
        esMatchesFilter: env.api + '/:lang/matches',

        userCheck: env.api + '/:lang/users/observe',
        // └─▶ POST
        //
        //     - email (String)
        //     - type (Int > 0)
        //     - observeId (Int > 0)

        userRegister: env.api + '/:lang/users/register',
        // └─▶ POST
        //
        //     - username (String)
        //     - captcha (String recaptcha -> readme.md)
        //     - email (String)
        //     - password (String)
        //     - passwordConfirm (String)
        //     - terms (Boolean)
        //     - newsletter (Boolean)
        //     - type (Int > 0)
        //     - observeId (Int > 0)

        404: env.api + '/:lang/not-found',

        test: env.api
    },

    page:
    {
        // :filter ──▶ games
        // counter-stricke-global-offensive, street-fighter-v, rocket-league

        // :slug ──▶ API code

        landing: '/',
        home: '/:lang/',
        news: '/:lang/news',
        article: '/:lang/news/:slug',
        teams: '/:lang/teams',
        teamProfile: '/:lang/teams/:slug',
        teamProfileFilter: '/:lang/teams/:slug/:filter',
        videos: '/:lang/videos',
        videosFilter: '/:lang/videos-highlights/:filter',
        videoPlayer: '/:lang/videos/:slug',
        watchNow: '/:lang/watch-now',
        gallery: '/:lang/gallery',
        galleryImage: '/:lang/gallery/:slug',
        policy: '/:lang/policy',
        sponsors: '/:lang/sponsors',
        terms: '/:lang/terms',
        copyright: '/:lang/copyright',
        intraVideo: '/:lang/intra/video',
        esAbout: '/:lang/elite-series-about',
        esMatches: '/:lang/elite-series-matches',
        esMatchesFilter: '/:lang/elite-series-matches/:filter',
        esMatchDetails: '/:lang/elite-series-matches/details/:slug',
        esMatchDetailsFilter: '/:lang/elite-series-matches/details/:slug/:filter',
        esMatchDetailsFilterLang: '/:lang/elite-series-matches/details/:slug/:filter/:langFilter',
        esStandings: '/:lang/elite-series-standings',
        esInformations: '/:lang/elite-series-informations',
        esSeason: '/:lang/elite-series-season/:slug',
        player: '/:lang/player/:slug',
        debug: '/:lang/debug/api',
        404: '*'
    },

    link:
    {
        buyTicket: '#'
    }
}



// WEBPACK FOOTER //
// ./src/config.url.js